import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MemberInfo } from "../../component/member";
import { Tabs } from "../../layout";
import Measurement from "../Measurement/Measurement";
import FreezeMembers from "../Freeze/FreezeMembers";
import MemberProfile from "./MemberProfile";
import { MemberProfAtt } from "..";
import { useParams } from "react-router-dom";
import { API, actions, endpoints } from "../../api/api";
import { useTranslation } from "react-i18next";

const ViewMember = () => {
  const { id } = useParams();
  const [member, setMember] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    id &&
      API(endpoints.Member + actions.GetById).getById(id, (res) => {
        res && res.status === 200 && setMember((x) => ({ ...res.result }));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} lg={9}>
          <div>
            <Tabs
              header={[
                { label: t("Profile") },
                { label: t("Attendance") },
                { label: t("Measurement") },
                { label: t("FreezeMember") },
              ]}
            >
              <MemberProfile memberId={member.id} />
              <MemberProfAtt memberId={member.id} />
              <Measurement memberId={member.id} />
              <FreezeMembers memberId={member.id} />
            </Tabs>
          </div>
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <MemberInfo member={member} />
        </Grid>
      </Grid>
    </>
  );
};

export default ViewMember;
